import React, { memo } from 'react';
import { Panel, PanelHeader, PanelBody } from '../../../components/panel/panel.jsx';
import FormGlobalSettings from './components/FormGlobalSettings.js';

import { useLocation } from 'react-router';

const GlobalSettingsView = () => {
  const location = useLocation();

  return (
    <div>
      <h1 className="page-header">Global Settings View</h1>
      <div className="row">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Information</PanelHeader>
            <PanelBody>
              <FormGlobalSettings action="update" values={{ ...location.state, attribute: '' }} />
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default memo(GlobalSettingsView);
